import styled from 'styled-components'

const EmailInput = styled.input.attrs({type: 'email'})`
  padding: 8px;
  text-align: center;
`

export default EmailInput
